export default {"src":"/_next/static/media/infoSolidGrey.19fe2f62.svg","height":12,"width":11,"blurWidth":0,"blurHeight":0};